import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const init = () => {
    const header = document.querySelector('.js-header');
    if (header) {
        gsap.timeline({
            scrollTrigger: {
                trigger: '.js-page',
                start: 'top -100px',
                end: 99999,
                toggleActions: 'play none none reverse',
                toggleClass: {
                    targets: header,
                    className: 'is-scrolled',
                },
            },
        });
    }
};

export default init;
